import styled from 'styled-components';

export const MessageFieldContainer = styled.div`
  display: flex;
  padding: 16px 0;

  span {
    padding: 5px 5px 5px 12px;
  }

  input {
    &::placeholder {
      opacity: 0.45;
    }
  }
`;
